import { RouterProvider } from 'react-router'
import ReactDOM from 'react-dom/client'
import router from './router'
import './styles/globals.css'
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client'
import '@ant-design/v5-patch-for-react-19'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // 禁用查询重试
      refetchOnWindowFocus: false, // 禁用窗口聚焦时自动重新请求
      refetchOnMount: false, // 禁用组件挂载时自动重新请求
      refetchOnReconnect: false, // 禁用网络重连时自动重新请求
    },
    mutations: {
      retry: false, // 禁用变更重试
    },
  },
})
const client = new ApolloClient({
  uri: '/graphql', // 使用相对路径，通过webpack代理转发
  cache: new InMemoryCache(),
})
dayjs.locale('zh-cn')

const root = document.getElementById('app')
ReactDOM.createRoot(root as HTMLElement).render(
  /* 
  <ApolloProvider client={client}>
    <RouterProvider router={router} />
  </ApolloProvider> */
  <ConfigProvider
    locale={zhCN}
    theme={{ token: { borderRadius: 8 } }}
    select={{ showSearch: false }}
  >
    <QueryClientProvider client={queryClient}>
      <ApolloProvider client={client}>
        <RouterProvider router={router} />
      </ApolloProvider>
    </QueryClientProvider>
  </ConfigProvider>
)
